module.exports = __webpack_public_path__ + "img/no.44d8a26c.png";